import dynamic from "next/dynamic";
import AllLogosLogosConfig from "./all-logos-logos-config";
import AllLogosLogosAdvancedConfig from "./all-logos-logos-advanced-config";
const AllLogosLogosComponent = dynamic(()=>import("./all-logos-logos-component"));
export default {
    AllLogosLogosComponent,
    AllLogosLogosConfig,
    AllLogosLogosAdvancedConfig
};
